import { render, staticRenderFns } from "./VideoClipListItem.vue?vue&type=template&id=20793da5&scoped=true&"
import script from "./VideoClipListItem.vue?vue&type=script&lang=ts&"
export * from "./VideoClipListItem.vue?vue&type=script&lang=ts&"
import style0 from "./VideoClipListItem.vue?vue&type=style&index=0&id=20793da5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20793da5",
  null
  
)

export default component.exports